module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetHigh.9d34450.webp";